import { ChannelState } from '@/composition/channels'
import { GroupState } from '@/composition/groups'
import { IChannel } from '@/models/Channels'
import { ChannelRoles, ChannelVisibility } from '@/models/Users'

export function checkChannelEditAccess(): boolean {
  if (
    ChannelState.state.currentChannelData &&
    ChannelState.state.currentChannelData.visibility === 'PRIVATE'
  ) {
    if (
      [ChannelRoles.MANAGER].includes(
        ChannelState.state.currentChannelData.userRole
      )
    ) {
      return true
    } else {
      return false
    }
  } else {
    if (GroupState.state.isGroupAdmin) {
      return true
    } else {
      return false
    }
  }
}

// Check if the user has access to post in the channel
export function isChannelRestricted(channel: IChannel): boolean {
  // If the channel is not an announcement, it is not restricted
  if (!channel?.isAnnouncement) {
    return false
  }

  // Public channel: user must be ADMIN or OWNER in the group
  // Private channel: user must be MANAGER in the channel
  // Note: Channel.userRole and channel.managers are only defined for private channels.
  if (
    (channel.visibility === ChannelVisibility.PUBLIC &&
      GroupState.state.isGroupAdmin) ||
    (channel.visibility === ChannelVisibility.PRIVATE &&
      channel.userRole === ChannelRoles.MANAGER)
  ) {
    return false
  }
  return true
}
